import { useQuery } from "@tanstack/react-query";
import { getPlayers } from "services/apiPlayers";

export function usePlayers(){
    const {isLoading, data: players, error} = useQuery({
        queryKey: ["players"],
        queryFn: getPlayers,
    });

    return {isLoading, error, players}
}